module.exports = __webpack_public_path__ + "static/img/feature_2.0cecb66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time-attendance/feature_2.png
// module id = HjKm
// module chunks = 0